'use client';
import { useEffect, useState } from 'react';

import { normalizeHash } from '@/lib/GlobalModalProvider/utils';

const useHash = () => {
  const [hash, setHash] = useState<string>(
    typeof window === 'undefined'
      ? ''
      : normalizeHash(window.location.hash || '')
  );

  useEffect(() => {
    function handleUrlChange() {
      setHash(normalizeHash(window.location.hash));
    }

    window.addEventListener('hashchange', handleUrlChange);
    window.addEventListener('popstate', handleUrlChange);

    return () => {
      window.removeEventListener('hashchange', handleUrlChange);
      window.removeEventListener('popstate', handleUrlChange);
    };
  }, []);

  function clearHash() {
    window.history.replaceState(
      {},
      document.title,
      window.location.pathname + window.location.search
    );
    window.dispatchEvent(new Event('hashchange'));
  }

  return { hash, clearHash };
};

export default useHash;
